import React from "react";
import { apiAssetUrl } from "./api";

interface RestaurantLogoProps {
  logoUrl?: string | null;
  /** 1 = fit as uploaded. Server clamps to [0.5, 2.5]; render defensively too. */
  logoScale?: number | null;
  alt: string;
  /** Tailwind size classes for the square container, e.g. "w-12 h-12". */
  sizeClassName: string;
  className?: string;
}

/**
 * The restaurant logo, in a rounded-square frame with a per-restaurant zoom.
 *
 * object-fit is always "contain": scaling only ever zooms the whole image
 * within the frame, it can never crop it. That matters because most uploaded
 * logos are not square (a wordmark, a wide banner), so a plain fixed frame
 * either crops badly (cover) or sits tiny with dead space either side
 * (contain at 1x); the admin's slider is what closes that gap per logo.
 */
const RestaurantLogo: React.FC<RestaurantLogoProps> = ({
  logoUrl, logoScale, alt, sizeClassName, className = "",
}) => {
  const src = apiAssetUrl(logoUrl ?? undefined) || "/placeholder-logo.svg";
  const scale = Math.min(2.5, Math.max(0.5, logoScale ?? 1));
  return (
    <div
      className={`${sizeClassName} rounded-xl bg-gray-100 overflow-hidden flex items-center justify-center border border-gray-200 shrink-0 p-1.5 ${className}`}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-contain"
        style={{ transform: `scale(${scale})` }}
      />
    </div>
  );
};

export default RestaurantLogo;
